import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>Sorry, This page not found</h1>
            <h1>400 Error</h1>
        </div>
    );
};

export default NotFound;